<template>
  <div></div>
</template>

<script>
import { mapState } from 'vuex';
import { EventBus, EVENTS } from '../libs/eventBus';
import BusinessLogicObservation from '../libs/businessLogicObservation';
import BusinessLogicAssessments from '../libs/businessLogicAssessments';

const clearTimer = (reference) => {
  // try to clear current interval, if there is one
  try {
    // console.log('clear interval', reference);
    clearInterval(reference);
  } catch (e) {
    // console.log(e);
  }
};

  export default {
    name: 'SyncService',
    data: () => ({
      intervalReference: null,
    }),
    computed: {
      ...mapState([
        'user',
        'observations',
        'assessments',
      ]),
    },
    mounted() {
      const self = this;

      const businessLogicObservation = new BusinessLogicObservation(this);
      const businessLogicAssessments = new BusinessLogicAssessments(this.$store, this.$apiRequest, this.$i18n);

      EventBus.$on(EVENTS.RESTART_SYNC, () => {
        // console.log('ReStart sync service');

        clearTimer(self.intervalReference);

        self.intervalReference = setInterval( () => {
          // console.log('SYNCING NOW');
          businessLogicObservation.syncAllObservations();
          // todo: Sync assessments
          EventBus.$emit(EVENTS.STOP_SYNC);
        }, 3000);

      });

      EventBus.$on(EVENTS.STOP_SYNC, () => {
        // console.log('Stop sync service');
        clearTimer(self.intervalReference);
      });

      EventBus.$on(EVENTS.IMMEDIATE_SYNC, () => {
        //console.log('Stop sync service');
        clearTimer(self.intervalReference);
        //console.log('SYNCING NOW');
        businessLogicObservation.syncAllObservations();
        // businessLogicAssessments.syncAllAssessments();
      });

    },
    beforeDestroy() {
      EventBus.$emit(EVENTS.STOP_SYNC)
    }
  };
</script>

<style scoped>

</style>
